const singType = Object.freeze({
  ByDefaultSignature: 1,
  BySignaturePad: 2,
  ByUploadFile: 3,
  ByUAEPass: 4
});
  export { singType };
